<template>
  <div :class="$style.container" ref="page">
    <div :class="$style.tips">
      <p>温馨提示</p>
      <p>1. 本月可开发票只针对服务费以及注册费。</p>
      <p>2. 本月产生的服务费以及注册费在下个月二号以后才可以索取发票。</p>
      <p>3. 发票基于订单开具，不可拆分开票。</p>
      <p>
        4. 识道网络单张发票金额限额100万，索取金额超过100万将拆分成多张发票开具。
      </p>
    </div>

    <Divider />

    <Loading v-show="!showDetail" :loading="loading" :text="loadingText">
      <!-- 发票管理搜索参数 -->
      <Row>
        <Item title="类型">
          <el-select v-model="status" placeholder="全部">
            <el-option
              v-for="(item, index) in invoiceTypeList"
              :key="index"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </Item>

        <Item title="交易时间">
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="选择日期"
          />
          <div :class="$style.divider"></div>
          <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="选择日期"
          />
        </Item>

        <Button :class="$style.btn" type="primary" @click="submitSearch(1)">
          查询
        </Button>
        <Button :class="$style.btn" @click="resetSearch">重置</Button>
      </Row>

      <!-- 发票管理搜索结果 -->
      <Title title="发票列表" :count="total" />

      <el-table
        ref="multipleTable"
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          prop="amount"
          label="发票金额"
          width="60"
          align="center"
        />

        <el-table-column
          prop="header"
          label="发票抬头"
          width="80"
          align="center"
        />

        <el-table-column
          prop="createdTime"
          label="申请时间"
          width="80"
          align="center"
        />

        <el-table-column
          prop="expressNum"
          label="快递信息"
          width="60"
          align="center"
        />

        <el-table-column label="状态" width="60" align="center">
          <template slot-scope="scope">
            {{ mapStatus[scope.row.status] }}
          </template>
        </el-table-column>

        <el-table-column
          prop="createdTime"
          label="操作"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <div :class="$style.action_btn">
              <span @click="toDetail(scope.row.id)">详情</span>
              <span
                v-if="scope.row.status < 3"
                @click="cancelInvoice(scope.row.id)"
                >取消</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="handlePageChange"
      />
    </Loading>

    <!-- 发票详情 -->
    <Button
      v-if="showDetail"
      :class="$style.btn_back"
      type="primary"
      size="small"
      @click="goBack"
    >
      返回
    </Button>

    <template v-if="showDetail">
      <ReceiptDetail :id="detailId" />
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getReceiptList, deleteInvoice } from "@server";
import { formatDate } from "@utils";
import { RECEIPT_STATUS_TYPE, MAP_RECEIPT_STATUS } from "@constant";

import ReceiptDetail from "./ReceiptDetail.vue";

export default {
  name: "ReceiptManage",
  components: {
    ReceiptDetail,
  },
  data() {
    return {
      mapStatus: MAP_RECEIPT_STATUS,
      statusList: RECEIPT_STATUS_TYPE,
      status: "",
      startTime: "",
      endTime: "",

      loading: false,
      loadingText: "加载中",
      page: 1,
      limit: 50,
      showList: [],
      total: 0,

      detailId: "", // 详情ID
      showDetail: false,
    };
  },
  computed: {
    ...mapState("user", ["amountInfo"]),
  },
  watch: {
    $route({ query }) {
      this.detailId = query.detailId || "";
      this.showDetail = !!query.detailId;
    },
  },
  methods: {
    async submitSearch(page = 1) {
      this.loading = true;
      this.page = page;

      const params = {
        page,
        limit: this.limit,
      };
      this.status !== "" && (params.status = this.status);
      this.startTime && (params.startTime = formatDate(this.startTime));
      this.endTime && (params.endTime = formatDate(this.endTime));

      const res = await getReceiptList(params);
      const { code, data } = res;
      if (code === 200) {
        this.showList = data.list;
        this.total = data.total;
      }
      this.loading = false;
    },

    resetSearch() {
      this.status = "";
      this.startTime = "";
      this.endTime = "";
      this.submitSearch();
    },

    toDetail(id) {
      this.showDetail = true;
      this.$router.push({ path: "/user/receipt", query: { detailId: id } });
      document.querySelector("#user-page").scrollIntoView();
    },

    cancelInvoice(id) {
      this.$confirm("确定要取消这条发票申请吗？", "取消确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loadingText = "正在取消...";
          this.loading = true;
          const res = await deleteInvoice({ id });

          if (res.code === 200) {
            this.$message({ message: "取消成功!", type: "success" });
            this.submitSearch();
          } else {
            this.$message({ message: res.message, type: "error" });
          }

          this.loading = false;
        })
        .catch(() => {});
    },

    handlePageChange(page) {
      this.submitSearch(page);
    },

    goBack() {
      this.$router.back();
    },
  },
  created() {
    this.submitSearch();
    const { query } = this.$route;
    this.detailId = query.detailId || "";
    this.showDetail = !!query.detailId;
  },
  mounted() {
    document.querySelector("#user-page").scrollIntoView();
  },
};
</script>

<style lang="scss" module scoped>
.container {
  min-height: 300px;
  position: relative;

  .tips {
    font-size: rem(14);
    color: #333;
    line-height: 32px;
    padding-bottom: rem(40);

    p:first-child {
      font-size: max(rem(16), 14px);
      font-weight: bold;
    }
  }

  :global {
    .gl-row {
      padding: rem(30) 0;
    }
    .gl-item {
      margin-right: rem(40);
    }
    .el-pagination {
      @include flex();
      margin-top: rem(50);
    }
  }

  .divider {
    width: 6px;
    height: 1px;
    background: #333;
    margin: 0 7px;
  }

  .action_btn {
    @include flex();
    gap: 20px;

    span {
      font-size: rem(14);
      color: #333;
      cursor: pointer;

      &:hover {
        color: $theme-color;
      }
    }
  }

  .btn {
    min-width: rem(80);
  }

  .btn_back {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 16px;
    color: $theme-color;
    background-color: #fff;
    border: 1px solid $theme-color;
    transform: scale(0.8);
    transition: all 0.1s;

    &:hover {
      background-color: rgba(255, 92, 53, 0.1);
    }
  }
}
</style>
